import React from 'react';
import { useLanguage } from '../../../features/language/useLanguage';

interface PurchaseOrderHeaderProps {
  onCreate: () => void;
  canWrite?: boolean;
}

export const PurchaseOrderHeader: React.FC<PurchaseOrderHeaderProps> = ({ onCreate, canWrite = true }) => {
  const { t } = useLanguage();
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <h1 className="text-2xl font-semibold text-gray-900">{t('purchaseOrder.table.title')}</h1>
      {canWrite && (
        <button
          data-test-id="po-create-button"
          onClick={onCreate}
          className="w-full sm:w-auto inline-flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-semibold bg-primary-600 text-white rounded-md hover:bg-primary-700 shadow-sm ring-1 ring-inset ring-primary-700/20 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {t('purchaseOrder.form.submit.create')}
        </button>
      )}
    </div>
  );
};
